document.addEventListener("DOMContentLoaded", function () {
  // Element references
  const stoneSizeEl = document.querySelector("#stoneSize");
  const depthEl = document.querySelector("#depth");
  const finishEl = document.querySelector("#finish");
  const sqftEl = document.querySelector("#sqft");
  const errorEl = document.querySelector("#error");
  const totalWeightEl = document.querySelector("#totalWeight");
  const bagsNeededEl = document.querySelector("#bagsNeeded");
  const palletsNeededEl = document.querySelector("#palletsNeeded");
  const calculateButton = document.querySelector("#calculateButton");

  // Set initial background color for the inputs
  [stoneSizeEl, depthEl, sqftEl].forEach((el) => {
    el.style.backgroundColor = "#fff";
  });

  // When the finish selection changes, update backgrounds and stone size options
  finishEl.addEventListener("change", function () {
    const selectedValue = this.value;

    // Update background colors based on finish selection
    if (selectedValue !== "Placeholder") {
      [stoneSizeEl, depthEl, sqftEl].forEach((el) => {
        el.style.backgroundColor = "#fff";
      });
    } else {
      [stoneSizeEl, depthEl, sqftEl].forEach((el) => {
        el.style.backgroundColor = "#ccc";
      });
    }

    // Update stone size select options based on finish value
    if (selectedValue === "Placeholder") {
      stoneSizeEl.innerHTML =
        "<option value='Placeholder' disabled selected>Select A Finish First</option>";
    } else if (selectedValue === "Polished") {
      stoneSizeEl.innerHTML =
        "<option value='Placeholder' disabled selected>Select A Size</option>" +
        "<option value='5.5'>.75-1.5&quot;</option>" +
        "<option value='7.5'>1.5-2.5&quot;</option>" +
        "<option value='11.5'>3-5&quot;</option>";
    } else if (selectedValue === "Unpolished") {
      stoneSizeEl.innerHTML =
        "<option value='Placeholder' disabled selected>Select A Size</option>" +
        "<option value='10'>1-2&quot;</option>" +
        "<option value='14'>2-3&quot;</option>" +
        "<option value='21'>3-5&quot;</option>";
    }
  });

  // Calculation function – reads values and computes outputs
  function calculateValues() {
    const sqft = parseFloat(sqftEl.value);
    const stonelayer = parseFloat(depthEl.value);
    const size = parseFloat(stoneSizeEl.value);

    let bagweight = 0;
    if (size == 5.5 || size == 7.5 || size == 11.5) {
      bagweight = 50;
    } else if (size == 10 || size == 14 || size == 21) {
      bagweight = 75;
    }

    let bagperpallet = 0;
    if (size == 5.5 || size == 7.5 || size == 11.5) {
      bagperpallet = 49;
    } else if (size == 10 || size == 14 || size == 21) {
      bagperpallet = 40;
    }

    // Compute results (pallets are rounded to the nearest half-pallet)
    const pallets =
      Math.ceil(((sqft * (size * stonelayer)) / bagweight / bagperpallet) * 2) /
      2;
    const totalweight = sqft * (size * stonelayer);
    let bagsneeded = (sqft * (size * stonelayer)) / bagweight;
    bagsneeded = Math.ceil(bagsneeded);

    // Validate inputs and display results
    if (isNaN(pallets) || isNaN(bagsneeded) || isNaN(totalweight)) {
      errorEl.innerHTML = "Please fill out all inputs";
      totalWeightEl.value = "";
      bagsNeededEl.value = "";
      palletsNeededEl.value = "";
    } else {
      errorEl.innerHTML = "";
      totalWeightEl.value = totalweight;
      bagsNeededEl.value = bagsneeded;
      palletsNeededEl.value = pallets;
    }
  }

  // Update calculations when inputs change
  stoneSizeEl.addEventListener("change", calculateValues);
  depthEl.addEventListener("change", calculateValues);
  sqftEl.addEventListener("input", calculateValues);

  // Calculate when the Calculate button is clicked
  calculateButton.addEventListener("click", function (e) {
    e.preventDefault();
    calculateValues();
  });
});
